<!--
 * @description: 公司信息
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="infoCompany"
      :condition="conditionData"
      :popNeedTransform="true"
      editType="pop"
      @popConfirmButtonClick="popConfirmButtonClick"
      :autoSearch="true"
      :clickRowSelected="false"
    >
      <template v-slot:tabelTitleRight>
        <add-button @buttonClick="add">新增</add-button>
        <downloadButton
          @buttonClick="handExport(conditionData)"
          style="margin-left: 10px"
          >导出</downloadButton
        >
      </template>

      <template v-slot:tabelTitleLeft>
        <div>公司信息</div>
      </template>
      <template v-slot:condition>
        <text-field
          v-model:value="conditionData.compnayName"
          labelText="公司名称："
          class="condition-container-input"
        >
        </text-field>
      </template>

      <template v-slot:oprator="$opData">
        <div class="opration">
          <div class="style-aaa" @click="delSingleCompant($opData.data)">
            删除
          </div>
          <!-- <del-border :useConfirm="true" comfirmMessage="确定删除吗？" comfirmOkText="确定" comfirmCancelText="取消"
            @buttonClick="delSingleCompant($opData.data)"></del-border> -->
        </div>
      </template>
    </tabel-panel>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import delBorder from "@/components/delBorder.vue";
import addButton from "@/components/addButton.vue";
import downloadButton from "@/components/downloadButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
// import popDialog from "@/components/popDialog.vue"
import tableApi from "@/api/tabel.js";
import { addCompany, DelCompany } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import { ElMessageBox } from "element-plus";
import { downloadExcel } from "@/util/download.js";
export default {
  name: "companyInfo",
  components: {
    tabelPanel,
    textField,
    delBorder,
    addButton,
    downloadButton,
    // popDialog
  },
  data() {
    //   shangji 公司方法
    const selectValueFn = (v, item) => {
      // debugger
      if (item) {
        return item.CompParent;
      }
    };
    // shangji 公司
    const selectRemoteSearchData = async () => {
      let source = await tableApi.ParentCompName();
      //   debugger
      if (source.code == 0) {
        let data = source.data.list.map(({ id, CompName }) => {
          return {
            label: CompName,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };

    // shangji 公司分区  取值
    //   shangji 公司方法
    const selectValueZoneFn = (v, item) => {
      // debugger
      if (item) {
        return item.CompSubarea;
      }
    };
    // shangji 公司分区
    // AddDate :  "2023-09-26T11:08:41.24"
    // Dic_Text:  "北京分区"
    // Dic_Value:  "1"
    const selectRemoteSearchDataZone = async () => {
      let source = await tableApi.ParentCompNameZone();
      if (source.code == 0) {
        let data = source.data.list.map(({ Dic_Value, Dic_Text }) => {
          return {
            label: Dic_Text,
            value: Dic_Text,
          };
        });
        let total = 0;
        // debugger
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };

    const checkboxDataSearchServe = (v, item) => {
      if (item) {
        return item.id;
      }
    };
    const selectRemoteSearchDataSearchServer = async () => {
      let source = await tableApi.ParentCompName({ searchServer: true });
      if (source.code == 0) {
        let data = source.data.list.map(({ id, CompName }) => {
          return {
            label: CompName,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };

    const checkboxData = (v, item) => {
      if (item) {
        return item.id;
      }
    };
    //货运公司  SearchCompany
    const checkboxDataComp = async () => {
      let source = await tableApi.SearchCompany();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    };
    // 公司权限
    const selectValueByCompany = (v, item) => {
      if (item) {
        return item.id;
      }
    };
    const selectRemoteDataForCompany = async () => {
      let arr = [
        {
          label: "客户",
          value: 1,
        },
        {
          label: "休恩公司",
          value: 2,
        },
        {
          label: "维修中心",
          value: 3,
        },
        {
          label: "维修返回公司",
          value: 4,
        },
      ];
      return {
        total: 0,
        data: arr,
      };
    };

    return {
      popDataObj: [
        {
          label: "申通",
          value: 0,
        },
      ],
      queryShow: false,
      rowTemplate: [
        {
          headerLabel: "公司编号",
          dataIndex: "id",
          width: 95,
          showInList: true,
          showInDetail: true,
          sortable: true,
          editType: "text",
          rules: [
            {
              required: true,
              message: "请输入用户名",
            },
          ],
          renderToHtml: true,
        },
        {
          headerLabel: "公司名称",
          width: 135,
          editable: true,
          sortable: true,
          clearable: true,
          dataIndex: "CompName",
          rules: [
            {
              required: true,
              message: "请输入公司",
            },
          ],
        },
        {
          headerLabel: "英文名称",
          editable: true,
          showInList: false,
          dataIndex: "EnCompName",
        },
        {
          headerLabel: "上级公司",
          width: 135,
          editable: false,
          editType: "text",
          dataIndex: "ParentCompName",
        },
        {
          headerLabel: "上级公司",
          editable: true,
          showInList: false,
          editType: "select",
          clearable: true,
          dataIndex: "ParentId",
          selectRemoteSearchData,
          selectValueFn,
        },
        {
          headerLabel: "公司分区",
          width: 135,
          editable: false,
          editType: "text",
          dataIndex: "CompSubarea",
        },
        {
          headerLabel: "公司分区",
          editable: true,
          showInList: false,
          editType: "select",
          clearable: true,
          dataIndex: "Subarea",
          selectRemoteSearchData: selectRemoteSearchDataZone,
          // selectValueFn,
          selectValueFn: selectValueZoneFn,
        },
        {
          headerLabel: "联系人",
          editable: true,
          sortable: true,
          dataIndex: "LinkMan",
        },
        {
          headerLabel: "电话",
          editable: true,
          sortable: true,
          dataIndex: "TelNo",
        },
        {
          headerLabel: "手机",
          editable: true,
          dataIndex: "CompCode",
          rules: [
            {
              required: true,
              message: "请输入手机号",
            },
          ],
        },
        {
          headerLabel: "传真",
          editable: true,
          showInList: false,
          dataIndex: "FaxNo",
        },
        {
          headerLabel: "Email",
          editable: true,
          showInList: false,
          dataIndex: "Email",
        },
        {
          headerLabel: "邮编",
          editable: true,

          showInList: false,
          dataIndex: "PostNo",
        },
        {
          headerLabel: "地址",
          width: 145,
          sortable: true,
          editable: true,
          editType: "textarea",
          dataIndex: "Address",
          rows: 2,
        },
        {
          headerLabel: "英文地址",
          editable: true,
          showInList: false,
          editType: "textarea",
          dataIndex: "EnAddress",
          rows: 2,
        },
        // {
        //   width: 60,
        //   headerLabel: "客户",
        //   editable: false,
        //   dataIndex: "TypeCustomer",
        //   editType: "checkbox",
        //   dataRender: (v,{row,column}) => {
        //     let flag=null
        //     if(typeof (row.TypeCustomer)=='object'){
        //    flag= row.TypeCustomer.findIndex(i=>i==1)

        //     }
        //    if(flag||v){
        //      return "是"
        //    }
        //   },
        // },
        {
          headerLabel: "公司权限",
          editable: true,
          dataIndex: "TypeArray",
          editType: "checkbox",
          showInList: false,
          selectRemoteSearchData: selectRemoteDataForCompany,
          selectValueFn: selectValueByCompany,
        },
        {
          width: 100,
          headerLabel: "休恩公司",
          editable: false,
          sortable: true,
          dataIndex: "TypeShooin",
          editType: "checkbox",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          width: 100,
          headerLabel: "维修中心",
          editable: false,
          sortable: true,
          dataIndex: "TypeService",
          editType: "checkbox",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          width: 100,
          headerLabel: "维修返回公司",
          editable: false,
          editType: "checkbox",
          showInList: false,
          dataIndex: "TypeShooinReturn",
        },
        {
          width: 360,
          headerLabel: "维修中心",
          editable: true,
          editType: "checkbox",
          showInList: false,
          dataIndex: "ServiceIdsStr",
          selectRemoteSearchData: selectRemoteSearchDataSearchServer,
          selectValueFn: checkboxDataSearchServe,
        },
        {
          headerLabel: "货运公司",
          editable: true,
          editType: "checkbox",
          showInList: false,
          dataIndex: "App1",
          selectRemoteSearchData: checkboxDataComp,
          selectValueFn: checkboxData,
        },
        {
          headerLabel: "收货公司",
          width: 100,
          sortable: true,
          dataIndex: "TypeShooinReturn",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "备注",
          editable: true,
          showInList: false,
          editType: "textarea",
          dataIndex: "Appendix",
          rows: 2,
        },
        {
          headerLabel: "操作",
          slot: "oprator",
        },
      ],
      conditionData: {
        compnayName: "",
      },
      // checkboxData:[]
    };
  },
  mounted() {},
  methods: {
    /**
     * @description: 重新加载数据
     * @param {*}
     * @return {*}
     */
    handExport({ compnayName }) {
      // compnayName
      tableApi.exportCompany({ compnayName }).then((res) => {
        console.log("导出red", res);
        downloadExcel(res, "公司信息");
      });
    },
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    // 增加
    add() {
      this.$refs.tabel.showDialog(null, "新增");
    },
    //单列表删除
    delSingleCompant({ row }) {
      let id = row.id;
      ElMessageBox.confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelCompany({ id }).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
              this.$refs.tabel.closeDialog();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },
    /**
     * @description: 双击表格之后确认事件
     * @param {*} slotData 为当前行的数据
     * @return {*}
     */

    popConfirmButtonClick({ slotData }) {
      console.log("提交1--", slotData);
      // console.log(slotData,'zengjiag')
      // return
      //   拆分数组为字符串
      if (slotData.App1 != null && typeof slotData.App1 != "string") {
        slotData.App1 = slotData.App1.join();
      }
      if (
        slotData.ServiceIdsStr != null &&
        typeof slotData.ServiceIdsStr != "string"
      ) {
        slotData.ServiceIdsStr = slotData.ServiceIdsStr.join();
      }
      // slotData.TypeShooinReturn;
      // if (slotData.TypeShooinReturn == undefined) {
      //   slotData.TypeShooinReturn = false;
      // }
      // if (slotData.TypeShooin == undefined) {
      //   slotData.TypeShooin = false;
      // }
      // if (slotData.TypeCustomer == undefined) {
      //   slotData.TypeCustomer = false;
      // }
      // if (slotData.TypeService == undefined) {
      //   slotData.TypeService = false;
      // }
      // slotData.TypeShooinReturn =
      //   typeof slotData.TypeShooinReturn == "boolean"
      //     ? slotData.TypeShooinReturn
      //     : slotData.TypeShooinReturn[0];
      // slotData.TypeShooin =
      //   typeof slotData.TypeShooin == "boolean"
      //     ? slotData.TypeShooin
      //     : slotData.TypeShooin[0];

      // slotData.TypeService =
      //   typeof slotData.TypeService == "boolean"
      //     ? slotData.TypeService
      //     : slotData.TypeService[0];
      if (!slotData.ParentId > 0) {
        slotData.ParentId = 0;
      }

      let { TypeCustomer, TypeArray } = slotData;

      // debugger
      if (typeof TypeArray == "string" && TypeArray.length > 0) {
        slotData.TypeCustomer = TypeArray.split(",");
      } else {
        slotData.TypeCustomer = TypeArray;
      }
      delete slotData.TypeArray;

      if (slotData.id) {
        console.log("parentId2--", slotData.parentId);
        // if(TypeCustomer.length && typeof (TypeCustomer[0])=='boolean'){
        //   slotData.TypeCustomer.splice(0,1)

        // }

        // TypeCustomer

        let powerObj = JSON.stringify(slotData);
        // debugger
        // return
        console.log("提交---", slotData);
        addCompany({ data: powerObj }).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.$refs.tabel.closeDialog();
          } else {
            errMsg(data.message);
          }
        });
      } else {
        // 总是会莫名其妙的传递为字符串
        // let {TypeCustomer}=slotData
        // if(typeof(TypeCustomer)=="string" && TypeCustomer.length>0){
        //   // debugger
        //   slotData.TypeCustomer=TypeCustomer.split(',')
        // }
        let powerObj = JSON.stringify(slotData);

        addCompany({ data: powerObj }).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.$refs.tabel.closeDialog();
          } else {
            errMsg(data.message);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .search-button-icon {
    background: none;
  }

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 350px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  ::v-deep
    .text-field-container
    .text-field-container-input-container
    .checkbox-group
    .checkbox-group-item {
    margin-left: 10px;
  }
}

::v-deep .el-table--scrollable-x .el-table__body-wrapper {
  overflow: auto !important;
}

::v-deep .el-form--label-top .el-form-item__label {
  line-height: 26px;
  padding: 8px 0 2px 0;
}
</style>
